import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-automotive",
  templateUrl: "./automotive.component.html",
  styleUrls: ["./automotive.component.scss"],
})
export class AutomotiveComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
